import { Mutation } from 'vuex';
import { IModuleState } from './types';

export const setColorTable: Mutation<IModuleState> = (state, payload) => {
  state.list.data = payload.data;
  state.list.loading = !!payload.loading;
};

export const setColorIndex: Mutation<IModuleState> = (state, payload) => {
  state.detail.data = payload.data;
  state.detail.loading = !!payload.loading;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
